import React, { Suspense } from "react";
import SupplierLayout from "../../layout/SupplierLayout";
import { SupplierStyle } from "./SupplierStyle";
import { Link, Route, Routes } from "react-router-dom";
import { SupplierRoute } from "../../routers/SupplierRoute";
import ProtectedRoute from "../../layout/ProtectedLayout/ProtectedRoute";
import { RouteMode } from "../../constant/enum/RouteAccessLevel";
import Loading from "../../components/Loadings/LoadingTable";
const renderRoute = () => {
  return SupplierRoute.map((route, index) => (
    <Route key={route.path} path={route.path} element={route.component} />
  ));
};

const Supplier = () => {
  return (
    <ProtectedRoute layoutMode={RouteMode.SUPPLIER}>
      <SupplierStyle>
        <SupplierLayout>
          <Suspense fallback={<Loading />}>
            <Routes>{renderRoute()}</Routes>
          </Suspense>
        </SupplierLayout>
      </SupplierStyle>
    </ProtectedRoute>
  );
};

export default Supplier;
